
import axios from 'axios'

export default {
  actions: {
    async echoApi({ commit }, message) {


      axios.get('/api/echo/' + message)
        .then(res => {
          commit('updateResult', res.data)
        })
        .catch(e => {
          commit('updateResult', {})
        })

    }
  },
  mutations: {
    updateResult(state, res) {
      state.result = res
    }
  },
  state: {
    result: null
  },
  getters: {
    getResult(s) {
      return s.result
    }
  }
}